@if(isLoader) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Cargando dispositivos'"></app-loader>
  </div>
}

<div class="p-6">
  <!-- Stepper -->
  <p-steps [model]="[
    {label: 'Dispositivo'},
    {label: 'Usuario'},
    {label: 'Configurar'},
    {label: 'QR Generado'}
  ]" [activeIndex]="step" [readonly]="true" class="mb-6" />

  <!-- ===== STEP 0: SELECT DEVICE ===== -->
  @if(step === 0) {
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-4 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input pInputText type="text" [(ngModel)]="searchText" placeholder="Buscar dispositivo..." (keyup)="searchByText($event)" class="w-full sm:w-72" />
        </p-iconfield>
        <span class="text-xs text-vivid-royal-400">* Solo se muestran dispositivos activos</span>
      </div>

      <!-- Desktop table -->
      <div class="hidden md:block">
      <p-table [value]="filteredTable" [paginator]="filteredTable.length > 12" [rows]="12"
        styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="flex"
        selectionMode="single" (onRowSelect)="getCardIdInfo($event.data)">
        <ng-template #header>
          <tr>
            <th>Dispositivo</th>
            <th>Usuario</th>
            <th>Descripción</th>
            <th>Placas</th>
            <th>Estado</th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr class="cursor-pointer hover:bg-vivid-royal-50 dark:hover:bg-vivid-royal-900" (click)="getCardIdInfo(item)">
            <td class="font-semibold">{{ item.vehicleFullNumber }}</td>
            <td>{{ item.nameUser }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.plates }}</td>
            <td>
              <span class="px-2 py-1 rounded-full text-xs font-semibold"
                [ngClass]="item.cardStatus === 'A' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
                {{ item.cardStatus === 'A' ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr><td colspan="5" class="text-center py-8 text-vivid-royal-400">No hay dispositivos por visualizar</td></tr>
        </ng-template>
      </p-table>
      </div>

      <!-- Mobile cards -->
      <div class="md:hidden space-y-2">
        @for(item of filteredTable; track item.cardId) {
          <div class="bg-vivid-royal-50 dark:bg-vivid-royal-900 rounded-lg p-3 cursor-pointer active:bg-vivid-royal-100" (click)="getCardIdInfo(item)">
            <div class="flex items-center justify-between">
              <span class="font-bold text-sm text-vivid-royal-800 dark:text-white">{{ item.vehicleFullNumber }}</span>
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
                [ngClass]="item.cardStatus === 'A' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
                {{ item.cardStatus === 'A' ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
            <p class="text-xs text-vivid-royal-400 mt-1">{{ item.nameUser }} · {{ item.plates }}</p>
          </div>
        }
        @if(filteredTable.length === 0) {
          <p class="text-center py-8 text-vivid-royal-400">No hay dispositivos por visualizar</p>
        }
      </div>
    </div>

    @if(msgError) {
      <div class="mt-3 px-4 py-2 rounded-lg text-sm bg-red-100 border border-red-300 text-center text-red-700">{{ msgError }}</div>
    }
  }

  <!-- ===== STEP 1: SELECT USER/DRIVER ===== -->
  @if(step === 1) {
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 mt-5 space-y-4">
      <!-- Resumen compacto del dispositivo -->
      <div class="flex flex-wrap items-center justify-between gap-3 pb-3 border-b border-dark-khaki-200 dark:border-vivid-royal-700">
        <div class="flex items-center gap-3">
          <i class="pi pi-credit-card text-vivid-royal-500 text-xl"></i>
          <div>
            <p class="text-sm font-bold text-vivid-royal-800 dark:text-white">{{ card.vehicleFullNumber }}</p>
            <p class="text-xs text-vivid-royal-400">{{ card.description }} · {{ card.nameUser }}</p>
          </div>
          @if(loadingBalance) {
            <span class="px-2 py-1 rounded-full text-xs font-semibold bg-vivid-royal-50 text-vivid-royal-400 dark:bg-vivid-royal-900 dark:text-vivid-royal-300">
              <i class="pi pi-spin pi-spinner mr-1"></i>Consultando saldo...
            </span>
          } @else if(cardInfo?.authSale != null) {
            <span class="px-2 py-1 rounded-full text-xs font-semibold bg-mustard-100 text-mustard-700 dark:bg-mustard-900 dark:text-mustard-300">
              Saldo: {{ cardInfo.authUnit === 'V' ? cardInfo.authSale + ' Lts' : (cardInfo.authSale | currency) }}
            </span>
          }
        </div>
        <div class="flex gap-2">
          <button pButton label="Ver consumos" icon="pi pi-list" class="p-button-sm p-button-outlined" [disabled]="loadingBalance" (click)="goToConsumptions();isFromCard=true"></button>
          <button pButton label="Cambiar" icon="pi pi-refresh" class="p-button-sm p-button-outlined" (click)="backButton()"></button>
        </div>
      </div>

      <!-- Selección de tipo -->
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-2 block">Selecciona quién generará el QR</label>
        <div class="flex gap-1">
          @for(t of typePerson; track t.value) {
            <button pButton [label]="t.text" class="p-button-sm" [outlined]="selectedType !== t.value" (click)="selectType(t.value)"></button>
          }
        </div>
      </div>

      @if(selectedType === 2) {
        @if(loadingUsers) {
          <div class="flex items-center gap-2 text-sm text-vivid-royal-400 py-4">
            <i class="pi pi-spin pi-spinner"></i> Cargando usuarios...
          </div>
        } @else {
          <app-custom-table-icon [headers]="headersUsers" [elements]="availableUsers"
            [emptyTableMessage]="'No hay usuarios por seleccionar'" [hasFilter]="true" [hasButton]="false"
            [iconColumn]="'userId'" [selectAllItemsButton]="false" [selectOnlyOne]="true"
            (dataSelect)="selectUser($event)"></app-custom-table-icon>
        }
      }

      @if(selectedType === 3) {
        @if(loadingUsers) {
          <div class="flex items-center gap-2 text-sm text-vivid-royal-400 py-4">
            <i class="pi pi-spin pi-spinner"></i> Cargando conductores...
          </div>
        } @else {
          <app-custom-table-icon [headers]="headersDrivers" [elements]="availableDrivers"
            [emptyTableMessage]="'No hay conductores por seleccionar'" [hasFilter]="true" [hasButton]="false"
            [iconColumn]="'driver_id'" [selectAllItemsButton]="false" [selectOnlyOne]="true"
            (dataSelect)="selectDriver($event)"></app-custom-table-icon>
        }
      }

      <div class="flex justify-end">
        <button pButton label="Siguiente" icon="pi pi-arrow-right" iconLayout="right" class="p-button-sm"
          [disabled]="loadingBalance || (selectedType === 2 && !selectedUser) || (selectedType === 3 && !selectedDriver)"
          (click)="nextStep()"></button>
      </div>
    </div>
  }

  <!-- ===== STEP 2: CONFIGURE ===== -->
  @if(step === 2) {
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 mt-5 space-y-5">
      <!-- Resumen compacto -->
      <div class="flex flex-wrap items-center justify-between gap-3 pb-3 border-b border-dark-khaki-200 dark:border-vivid-royal-700">
        <div class="flex flex-wrap items-center gap-3">
          <i class="pi pi-credit-card text-vivid-royal-500 text-xl"></i>
          <div>
            <p class="text-sm font-bold text-vivid-royal-800 dark:text-white">{{ card.vehicleFullNumber }}</p>
            <p class="text-xs text-vivid-royal-400">{{ card.description }} · Saldo: {{ cardInfo.authUnit === 'V' ? cardInfo.authSale + ' Lts' : (cardInfo.authSale | currency) }}</p>
          </div>
          <span class="px-2 py-1 rounded-full text-xs font-semibold bg-vivid-royal-100 text-vivid-royal-700 dark:bg-vivid-royal-900 dark:text-vivid-royal-200">
            <i class="pi pi-user mr-1"></i>{{ getTextUser() }}
          </span>
        </div>
        <button pButton label="Regresar" icon="pi pi-arrow-left" class="p-button-sm p-button-outlined" (click)="backButton()"></button>
      </div>

      <!-- Producto y tipo de carga -->
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Producto</label>
          <p-select [options]="prodcutTypeValue" [(ngModel)]="selectedValueProduct" optionLabel="text" optionValue="value"
            (onChange)="onProductChange($event)" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Tipo de carga</label>
          <p-select [options]="loadTypeValue" [(ngModel)]="selectedValueLoadType" optionLabel="text" optionValue="value"
            (onChange)="onLoadTypeChange($event)" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">
            {{ selectedValueLoadType === 1 ? 'Litros' : 'Importe ($)' }}
          </label>
          <input pInputText type="text" [(ngModel)]="amountInput" autocomplete="off" placeholder="0.00" mask="separator.2"
            [allowNegativeNumbers]="false" maxlength="15" class="w-full mt-1 text-right" />
        </div>
      </div>

      <!-- Opciones -->
      <div class="flex flex-wrap items-center gap-6 pt-2 border-t border-dark-khaki-100 dark:border-vivid-royal-700">
        <div class="flex items-center gap-2">
          <p-toggleswitch [(ngModel)]="isChecked" [disabled]="!cardInfo.askOdometerLecture" />
          <label class="text-sm text-vivid-royal-600 dark:text-vivid-royal-200">Validar km en estación</label>
        </div>
        @if(data.ExceptionGeneration === 1) {
          <div class="flex items-center gap-2">
            <p-toggleswitch [(ngModel)]="isCheckedTmp" />
            <label class="text-sm text-vivid-royal-600 dark:text-vivid-royal-200">QR Temporal</label>
          </div>
        }
      </div>

      <!-- Kilometraje manual -->
      @if(!isChecked) {
        <div class="max-w-xs">
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Kilometraje</label>
          <input pInputText type="text" [(ngModel)]="kmInput" mask="0*" maxlength="15" autocomplete="off" placeholder="0" class="w-full mt-1 text-right" />
        </div>
      }

      <!-- Botón generar -->
      <div class="flex justify-end pt-2">
        <button pButton [label]="enProceso ? 'Generando...' : 'Generar QR'" [icon]="enProceso ? 'pi pi-spin pi-spinner' : 'pi pi-qrcode'" class="p-button-sm"
          [disabled]="!(amountInput && (isChecked || kmInput)) || enProceso"
          (click)="generateQR()"></button>
      </div>
    </div>
  }

  <!-- ===== STEP 3: QR RESULTS ===== -->
  @if(step === 3) {
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5 space-y-4 mt-5">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400">Códigos Generados</h2>
        <div class="flex gap-2">
          @if(isFromCard) {
            <button pButton label="Regresar" icon="pi pi-arrow-left" class="p-button-sm p-button-outlined" (click)="step=1"></button>
          }
          <button pButton label="Ver dispositivos" icon="pi pi-th-large" class="p-button-sm" (click)="resetScreen()"></button>
        </div>
      </div>
      <app-custom-table [headers]="headers" [elements]="items" [emptyTableMessage]="'No hay códigos QR generados'"
        [hasFilter]="true" [hasButton]="true"></app-custom-table>
    </div>
  }
</div>

<!-- Modal: Comentarios antes de generar QR -->
<p-dialog header="Comentarios del QR" [(visible)]="showModal" [modal]="true" [style]="{width: '28rem'}"
  *ngIf="!showQR && !showWhatapp">
  <div class="space-y-4">
    <p class="text-sm text-vivid-royal-500">Opcional: agrega descripción, comentarios o referencia al código QR.</p>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Descripción</label>
      <input pInputText type="text" [(ngModel)]="qrDescription" maxlength="20" class="w-full mt-1" placeholder="Ej: Carga semanal" />
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Comentarios</label>
      <textarea pInputText [(ngModel)]="qrComments" maxlength="100" rows="3" class="w-full mt-1" placeholder="Ej: Ruta norte"></textarea>
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Referencia</label>
      <input pInputText type="text" [(ngModel)]="qrReference" maxlength="20" class="w-full mt-1" placeholder="Ej: OC-001" />
    </div>
  </div>
  <ng-template #footer>
    <button pButton label="Omitir" class="p-button-sm p-button-outlined" (click)="sendInfoQR({description:'',comment:'',reference:''})"></button>
    <button pButton label="Generar QR" icon="pi pi-qrcode" class="p-button-sm"
      (click)="sendInfoQR({description: qrDescription, comment: qrComments, reference: qrReference})"></button>
  </ng-template>
</p-dialog>

<!-- Modal: QR generado exitosamente -->
<p-dialog header="Código generado" [(visible)]="showSuccessModal" [modal]="true" [style]="{width: '24rem'}">
  <div class="text-center space-y-3">
    <i class="pi pi-check-circle text-green-500 text-5xl"></i>
    <p class="text-sm text-vivid-royal-600 dark:text-vivid-royal-200">
      {{ isCheckedTmp ? 'Ingresa a WhatsApp para consultarlo' : 'Ingresa a la aplicación móvil para consultarlo' }}
    </p>
  </div>
  <ng-template #footer>
    <button pButton label="Cerrar" class="p-button-sm p-button-outlined" (click)="showSuccessModal=false"></button>
  </ng-template>
</p-dialog>

<!-- Modal: Detalle de QR existente -->
<p-dialog header="Detalle del QR" [(visible)]="showDetailModal" [modal]="true" [style]="{width: '28rem'}">
  @if(dataQR) {
    <div class="space-y-3">
      <div class="text-center py-2 rounded-md text-sm font-semibold"
        [ngClass]="dataQR.status === 1 ? 'bg-green-100 text-green-700' : 'bg-mustard-100 text-mustard-700'">
        {{ generateStatusText(dataQR.status, dataQR.expiration) }}
      </div>
      <div class="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2 text-sm">
        <span class="font-semibold text-vivid-royal-600 dark:text-vivid-royal-200">Folio:</span>
        <span>{{ dataQR.id }}</span>
        <span class="font-semibold text-vivid-royal-600 dark:text-vivid-royal-200">Expiración:</span>
        <span>{{ dataQR.expiration }}</span>
        <span class="font-semibold text-vivid-royal-600 dark:text-vivid-royal-200">Tarjeta:</span>
        <span>{{ dataQR.card }}</span>
        <span class="font-semibold text-vivid-royal-600 dark:text-vivid-royal-200">Cantidad:</span>
        <span>{{ dataQR.amount }}</span>
      </div>
    </div>
  }
  <ng-template #footer>
    <button pButton label="Cerrar" class="p-button-sm p-button-outlined" (click)="showDetailModal=false"></button>
  </ng-template>
</p-dialog>


